import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=10089a03&"
import script from "./Questions.vue?vue&type=script&lang=js&"
export * from "./Questions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10089a03')) {
      api.createRecord('10089a03', component.options)
    } else {
      api.reload('10089a03', component.options)
    }
    module.hot.accept("./Questions.vue?vue&type=template&id=10089a03&", function () {
      api.rerender('10089a03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Questions.vue"
export default component.exports